import { TouchableOpacity } from "react-native";
export default TouchableOpacity;
//# sourceMappingURL=Touchable.web.js.map